var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42474D",
    fillRule: "evenodd",
    d: "M6.141.321a1.08 1.08 0 0 1 1.543.007 1.12 1.12 0 0 1-.007 1.568L5.113 4.48C4.072 5.527 3.358 6.25 2.875 6.86c-.47.594-.63.975-.673 1.317a2.6 2.6 0 0 0 0 .646c.043.342.204.723.673 1.317.483.611 1.197 1.333 2.238 2.38l2.564 2.584c.428.43.431 1.133.007 1.568a1.08 1.08 0 0 1-1.543.007l-2.61-2.63c-.984-.99-1.787-1.8-2.357-2.52C.58 10.778.152 10.016.038 9.102c-.05-.4-.05-.806 0-1.206.114-.914.543-1.675 1.136-2.425.57-.721 1.373-1.53 2.357-2.521z",
    clipRule: "evenodd"
  })));
};
export { SvgBack as ReactComponent };